class Magazine {
  constructor() {
    this.frontpage = document.querySelector('.magazine-frontpage');
    this.initialAmount = 5;

    if (!!this.frontpage) {
      this.visibleTiles = this.frontpage.querySelector('.magazine-content--first');
      this.hiddenTiles = this.frontpage.querySelector('.magazine-content--hidden');
      this.tiles = Array.from(document.querySelectorAll('.magazine-tile'));
      this.topicTriggers = document.querySelectorAll('.topics-container .topic');
      this.sectionTriggers = document.querySelectorAll('.section-container .section');
      this.init();
      this.initNav();

      this.readMore = document.querySelector('.js-magazine-read-more');

      switch (document.documentElement.lang) {
        case 'de':
          this.readMoreString = 'Mehr Artikel anzeigen';
          this.readLessString = 'Weniger Artikel anzeigen';
          break;
        case 'fr':
          this.readMoreString = 'Afficher plus d\’articles';
          this.readLessString = 'Afficher moins d\’articles';
          break;
        default:
          this.readMoreString = 'Mehr Artikel einblenden';
          this.readLessString = 'Weniger Artikel anzeigen';
          break;
      }

      if (this.readMore) {
        this.initReadMore();
      }
      this.initGetParams();
    } else{
      const topicButtons = document.querySelectorAll('.topic-buttons > .magazin-button');
      const sectionButtons = document.querySelectorAll('.section-buttons > .magazin-button');
      if(!!topicButtons || !!sectionButtons){
        this.handleArticleLinks(topicButtons, sectionButtons);
      }
    }
  }

  init() {
    this.tiles.forEach((tile, index) => {
      this.renderLegends();

      if (index < this.initialAmount) {
        this.visibleTiles.appendChild(tile);
      } else {
        this.hiddenTiles.appendChild(tile);
      }
    });
  }


  renderLegends() {
    const tiles = document.querySelectorAll('.magazine-tile');
    const topicButtons = document.querySelectorAll('.topics-container .topic');
    const sectionButtons = document.querySelectorAll('.section-container .section');

    tiles.forEach(tile => {
      const tileTopics = tile.classList;
      const tileLegendTop = tile.querySelector('.magazine-tile__legend--top');
      const tileLegendBottom = tile.querySelector('.magazine-tile__legend--bottom');

      topicButtons.forEach(button => {
        const buttonId = button.id;

        if (tileTopics.contains(buttonId)) {
          if (!tileLegendTop.querySelector(`.magazine-tile__legend--item[data-topic="${buttonId}"]`)) {
            const legendItem = document.createElement('span');
            legendItem.classList.add('magazine-tile__legend--item');
            legendItem.setAttribute('data-topic', buttonId);
            legendItem.textContent = button.textContent;

            tileLegendTop.appendChild(legendItem);
          }
        }
      });

      sectionButtons.forEach(button => {
        const buttonId = button.id;

        if (tileTopics.contains(buttonId)) {
          if (!tileLegendBottom.querySelector(`.magazine-tile__legend--item[data-section="${buttonId}"]`)) {
            const legendItem = document.createElement('span');
            legendItem.classList.add('magazine-tile__legend--item');
            legendItem.setAttribute('data-section', buttonId);
            legendItem.textContent = button.textContent;

            tileLegendBottom.appendChild(legendItem);
          }
        }
      });
    });
  }

  initNav() {
    this.topicTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        trigger.classList.toggle('active');
        this.renderTileWithFilter();
      });
    });

    this.sectionTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        trigger.classList.toggle('active');
        this.renderTileWithFilter();
      });
    });
  }

  renderTileWithFilter() {
    this.visibleTiles.innerHTML = '';
    this.hiddenTiles.innerHTML = '';
    let index = 0;

    this.tiles.forEach(tile => {
      const matchesTopicFilter = Array.from(this.topicTriggers)
        .filter(trigger => trigger.classList.contains('active'))
        .map(trigger => trigger.id)
        .some(filter => tile.classList.contains(filter));

      const matchesSectionFilter = Array.from(this.sectionTriggers)
        .filter(trigger => trigger.classList.contains('active'))
        .map(trigger => trigger.id)
        .some(filter => tile.classList.contains(filter));

      const noTopicFilter = Array.from(this.topicTriggers).every(trigger => !trigger.classList.contains('active'));
      const noSectionFilter = Array.from(this.sectionTriggers).every(trigger => !trigger.classList.contains('active'));

      if ((matchesTopicFilter || noTopicFilter) && (matchesSectionFilter || noSectionFilter)) {
        if (index < this.initialAmount) {
          this.visibleTiles.appendChild(tile);
        } else {
          this.hiddenTiles.appendChild(tile);
        }
        index++;
      }
    });

    this.updateReadMoreVisibility();
  }

  initReadMore() {
    this.closeReadMore();
    this.readMore.addEventListener('click', event => {
      event.preventDefault();
      if (this.hiddenTiles.classList.contains('open')) {
        this.closeReadMore();
      } else {
        this.openReadMore();
      }
    });

    this.updateReadMoreVisibility();
  }

  updateReadMoreVisibility() {
    if (this.hiddenTiles.children.length === 0) {
      this.readMore.classList.add('hidden');
    } else {
      this.readMore.classList.remove('hidden');
    }
  }

  closeReadMore() {
    this.hiddenTiles.classList.remove('open');
    this.readMore.innerHTML = `
      <div class="read-more-container">
          <span class="read-more-string">${this.readMoreString}</span>
          <span class="magazin-read-more__arrow">
              <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.303286 0.301043C0.707574 -0.100348 1.36914 -0.100348 1.77342 0.301043L8.24271 6.7522L14.712 0.301043C15.1163 -0.100348 15.7778 -0.100348 16.1821 0.301043C16.5864 0.702433 16.5864 1.35925 16.1821 1.76064L8.97778 8.9416C8.57349 9.34299 7.91193 9.34299 7.50764 8.9416L0.303286 1.77281C-0.101002 1.35925 -0.101002 0.702433 0.303286 0.301043Z" fill="#9A0941"/>
              </svg>
          </span>
      </div>`;
  }

  openReadMore() {
    this.hiddenTiles.classList.add('open');
    this.readMore.innerHTML = `
    <div class="read-more-container">
        <span class="read-more-string">${this.readLessString}</span>
        <span class="magazin-read-more__arrow magazin-read-more__arrow--up">
            <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.303286 0.301043C0.707574 -0.100348 1.36914 -0.100348 1.77342 0.301043L8.24271 6.7522L14.712 0.301043C15.1163 -0.100348 15.7778 -0.100348 16.1821 0.301043C16.5864 0.702433 16.5864 1.35925 16.1821 1.76064L8.97778 8.9416C8.57349 9.34299 7.91193 9.34299 7.50764 8.9416L0.303286 1.77281C-0.101002 1.35925 -0.101002 0.702433 0.303286 0.301043Z" fill="#9A0941"/>
        </span>
    </div>`;
  }

  initGetParams() {
    let getParams = window.location.href.split('?');
    let filterParams = [];

    if (getParams.length > 1) {
      getParams = getParams[1].split('#')[0].split('&');
      getParams.forEach((param) => {
        let key = param.split('=')[0];
        let value = param.split('=')[1];

        filterParams[key] = value;
      });
    }

    if (filterParams['topics']) {
      document.querySelector(`#${filterParams['topics']}`).classList.add('active');
      this.renderTileWithFilter();
    }
    if (filterParams['sections']) {
      document.querySelector(`#${filterParams['sections']}`).classList.add('active');
      this.renderTileWithFilter();
    }
  }

  handleArticleLinks(topicButtons, sectionButtons){
    const json = this.getJSON();
    const projectBase = document.querySelector('#frontpage');


    topicButtons.forEach(topicButton => {
      topicButton.addEventListener('click', () => {
        window.location.href = `${projectBase.value}?topics=${topicButton.id}`;
      });
    });

    sectionButtons.forEach(sectionButton => {
      sectionButton.addEventListener('click', () => {


        window.location.href = `${projectBase.value}?sections=${this.findItem(json, sectionButton.innerText)}`;
      });
    });
  }

  findItem(json, langString){
    const item = json.find(item => item.de === langString || item.fr === langString);
    return item ? item.id : null;
  }


  getJSON() {
    const jsonData = [
      {
        "id": "topic-1",
        "de": "Gesundheitsakteure im Wettbewerb",
        "fr": "Acteurs de la santé en concurrence"
      },
      {
        "id": "topic-2",
        "de": "Versorgung & Qualität",
        "fr": "Soins & qualité"
      },
      {
        "id": "topic-3",
        "de": "Prämien & Finanzierung",
        "fr": "Primes et financement"
      },
      {
        "id": "section-1",
        "de": "Risikoausgleich",
        "fr": "Compensation des risques"
      },
      {
        "id": "section-2",
        "de": "Daten",
        "fr": "Données"
      },
      {
        "id": "section-3",
        "de": "Tarifpartnerschaft",
        "fr": "Partenariat tarifaire"
      },
      {
        "id": "section-4",
        "de": "Zusatzversicherung",
        "fr": "Assurance complémentaire"
      },
      {
        "id": "section-5",
        "de": "EFAS",
        "fr": "EFAS"
      },
      {
        "id": "section-6",
        "de": "Reserve",
        "fr": "Réserves"
      },
      {
        "id": "section-7",
        "de": "Interview",
        "fr": "Entretien"
      },
      {
        "id": "section-8",
        "de": "Tumormarker",
        "fr": "Marqueurs tumoraux"
      },
      {
        "id": "section-9",
        "de": "Spitalplanung",
        "fr": "Planification hospitalière"
      },
      {
        "id": "section-10",
        "de": "Integrierte Vorsorgung",
        "fr": "Soins intégrés"
      }

    ];

    return jsonData;
  }

}
export default Magazine;
